module.exports = __webpack_public_path__ + "img/empty-state.2d7141b0.svg";